// Function to remove an item from the cart
function removeItemFromCart(lineItemKey) {
  return new Promise((resolve, reject) => {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {
        id: lineItemKey,
        quantity: 0,
      },
    })
      .done(function (updatedCart) {
        resolve(updatedCart);
        console.log("Item '" + lineItemKey + "' removed from the cart.");
      })
      .fail(function (error) {
        console.error('Error removing item:', error);
        reject(error);
      });
  });
}

// Function to fetch the cart data
const fetchCartData = async () => {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error('Failed to fetch cart data');
    }
    const cartData = await response.json();
    return cartData;
  } catch (error) {
    console.error('Error fetching cart data:', error);
    return null;
  }
};

// Function to remove lonely related products from the cart
const removeLonelyRelatedProductsFromCart = async () => {
  try {
    const cartData = await fetchCartData();
    if (!cartData) return; // Exit if cart data could not be fetched

    const baseProductIds = cartData.items
      .filter(item => !item.properties?._related_product_id)
      .map(item => item.properties?._product_id);

    for (const item of cartData.items) {
      const relatedProductId = item.properties?._related_product_id;
      if (relatedProductId && !baseProductIds.includes(relatedProductId)) {
        // If a related product doesn't have its base product, remove it
        await removeItemFromCart(item.key);
      }
    }
  } catch (error) {
    console.error('Error in removeLonelyRelatedProductsFromCart:', error);
  }
};

// Ensure the function runs on page load
document.addEventListener('DOMContentLoaded', function () {
  removeLonelyRelatedProductsFromCart();
});

// Add event listeners for quantity update events
document.addEventListener('quantityUpdated', function () {
  removeLonelyRelatedProductsFromCart();
});
document.addEventListener('quantityUpdatedForRelatedProducts', function () {
  removeLonelyRelatedProductsFromCart();
});
